import { Button } from 'app/components/ui/Button'
import { Separator } from 'app/components/ui/Separator'
import { Text } from 'app/components/ui/Text'
import { Title } from 'app/components/ui/Title'
import { AuthenticationContext } from 'app/Contexts/AuthenticationProvider'
import { routes } from 'app/routes'
import React, { useContext } from 'react'
import styled from 'styled-components'

interface Props {
  onReUploadDocumentRequest?: () => void
}

export const CompleteRegistration: React.FC<Props> = ({
  onReUploadDocumentRequest,
}) => {
  const authCtx = useContext(AuthenticationContext)

  const supplier = authCtx?.actor?.supplier

  if (!supplier) return null

  // User need to complete the form with his data
  const isProfileDataNotCompleted = supplier.status === 'invited'

  // User need to upload his document and sign the pdf
  const areProfileDocumentsNotUploaded =
    supplier.status === 'ready_for_registry'

  const isProfileRejected = supplier.status === 'rejected'

  return (
    <>
      {isProfileDataNotCompleted || areProfileDocumentsNotUploaded ? (
        <RegistrationWrapper>
          <Wrapper>
            <Title size={3}>Completa la registrazione</Title>
            <Text variant='s16'>
              Per lavorare insieme abbiamo bisogno di alcuni dati: completa la
              tua anagrafica, allega un documento ed inviacela firmata
            </Text>
            <Button
              to={
                isProfileDataNotCompleted
                  ? routes.editProfile.makeUrl() // Go to profile form
                  : routes.profile.makeUrl() // Go to document step
              }
              size='lg'
            >
              PROCEDI
            </Button>
          </Wrapper>
          <Separator></Separator>
        </RegistrationWrapper>
      ) : (
        isProfileRejected && (
          <RegistrationWrapper>
            <Wrapper>
              <Title size={3}>Anagrafica Rifiutata</Title>
              <Text variant='s16'>
                La tua anagrafica fornitore è stata rifiutata per il seguente
                motivo: {supplier.pdf_registry_notes}
              </Text>
              <ButtonWrapper>
                <Button to={routes.editProfile.makeUrl()}>
                  Aggiorna i tuoi dati
                </Button>
                <Button onClick={onReUploadDocumentRequest}>
                  Aggiorna documento titolare
                </Button>
              </ButtonWrapper>
            </Wrapper>
            <Separator></Separator>
          </RegistrationWrapper>
        )
      )}
    </>
  )
}

const RegistrationWrapper = styled.div`
  margin-bottom: 6rem;
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  //Add margin to children
  > * {
    margin-bottom: 3rem;
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  > * {
    margin-bottom: 1.5rem;
  }
`
